
import React, { Fragment, useState } from 'react'
import SituationTab from '../../LeadsTabs/OpportunityDetails/SituationTab';
import isEqual from 'lodash/isEqual';
import _ from 'lodash';
import DateComp from '../../../../core/common/dateComponent/DateComp';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';

const SummaryWizardData = ({ compareOpportunityDetailData, totalAmount, contactInfoData, saleInfoData, opportunityData, saleInfoApi, opportunityInitialValues }: any) => {

  const mappedData: Record<string, string | null> = compareOpportunityDetailData?.result?.reduce(
    (acc: Record<string, string | null>, item: any) => {
      let revised = item?.surveyResultRevised ?? "";
      let original = item?.surveyResultOriginal ?? "";
  
      if (item?.fieldType === "Option") {
        revised = revised === "2" ? "Yes" : (revised === "0" ? "false" : revised); 
        original = original === "1" ? "Yes" : (original === "0" ? "false" : original);
      }
  
      let valueParts: string[] = [];
      if (revised && revised !== "") valueParts.push(`Revised: ${revised}`);
      if (original && original !== "") valueParts.push(`Original: ${original}`);
  
      const value = valueParts.join(", ");
  
      if (valueParts.length > 0) {
        acc[item?.name] = value;
      }
  
      return acc;
    },
    {} as Record<string, string | null>
  );
  
  const formatComma = (num: number | string) => {
    if (num === null || num === undefined) return "0.0";
    const numericValue = String(num).replace(/,/g, "");
    if (isNaN(Number(numericValue))) return String(num);
    return Number(numericValue).toLocaleString();
};
  return (
    <>
      <div className='row p-2 br-gray mb-2'>
        <h5 className='color-red mt-2 mb-2'>Contact Info</h5>
        <div className='col-md-6'>
          <h6 className='mt-2 mb-2'>Primary Contact</h6>
          <div className='d-flex'>
            <p className='w-25 mb-0'>
              Contact Name:
            </p>
            <p>
              {contactInfoData?.primaryContactVMs?.firstName} {contactInfoData?.primaryContactVMs?.lastName}
            </p>
          </div>
        </div>
        <div className='col-md-6'>
          <h6 className='mt-2 mb-2'>Telephone Numbers</h6>
          <div className='d-flex'>
            <p className='w-25 mb-0'>
              Cell Phone:
            </p>
            <p>
              {contactInfoData?.primaryContactVMs?.homePhone}
            </p>
          </div>
        </div>
        <div className='col-md-6'>
          <h6 className='mt-2 mb-2'>Email Address</h6>
          <div className='d-flex'>
            <p className='w-25 mb-0'>
              Home Email:
            </p>
            <p>
              {contactInfoData?.primaryContactVMs?.homeEmail}

            </p>
          </div>
        </div>
        <div className='col-md-6'>
          <h6 className='mt-2 mb-2'>Mailing Address</h6>
          <div className='d-flex '>
            <p className='w-25 mb-0'>
              Address:
            </p>
            <p>
             {' '} {contactInfoData?.primaryContactVMs.mailingAddress?.addressLine1}

            </p>
          </div>
        </div>
        <div className='col-md-6'>
          <h6 className='mt-2 mb-2'>Property Address</h6>
          <div className='d-flex'>
            <p className='w-25 mb-0'>
              Address:
            </p>
            <p>
              {contactInfoData?.primaryContactVMs?.propertyAddress?.addressLine1}
            </p>
          </div>
        </div>
        <div className='col-md-6'>
          <h6 className='mt-2 mb-2'>Sales Info</h6>
          <div className='d-flex gap-5'>
            <p className='mb-0'>
              Designer:
            </p>
            <p className='mb-0'>
              {saleInfoData?.lst_SaleRepresentative?.value}
            </p>
          </div>
          <div className='d-flex gap-5'>
            <p className='mb-0'>
              Sale Date:
            </p>
            <p>
             <DateComp formattedDate={saleInfoData?.saleDate}/>
            </p>
          </div>
        </div>
      </div>
      <div className='row p-2 br-gray mb-2'>
        <h5 className='color-red mb-2'>Job Description</h5>

        <div className='col-md-6'>
          <div className='d-flex'>
            <p className='w-50'>
              Job Type:
            </p>
            <p>
              {opportunityData?.values?.opportunityDetailsDescription?.jobType?.value}
            </p>
          </div>
        </div>
        <div className='col-md-6'>
          <div className='d-flex'>
            <p className='w-50'>
              Job Description:
            </p>
            <p>
              {opportunityData?.values?.opportunityDetailsDescription?.description}
            </p>
          </div>
        </div>
      </div>
      <div className='row mb-2 p-2 br-gray'>
        <h5 className='color-red mb-2'>
          Job Scope
        </h5>
        <div>
          {mappedData && Object.keys(mappedData).length > 0 ? (
            <ul>
              {Object.entries(mappedData).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))}
            </ul>
          ) : (
            <p>No data available</p>
          )}
        </div>
      </div>

      <h5 className='color-red mb-2'>
        Payment Schedule
      </h5>
      <div className='col-md-12 '>
        <div className="table-responsive mt-2 overflow-auto">
          <table className="table datanew dataTable no-footer table-hover">
            <thead>
              <tr>
                <th>
                  Payment Type
                </th>
                <th>
                  Payment Amt
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>Contract Amount</b>
                </td>
                <td>
                  <FormattedNumber value={totalAmount} />
                </td>
              </tr>
              {saleInfoData?.projectPaymentSchedule?.map((apiItem: any, index: number) => {
                const dataItem = saleInfoData?.projectPaymentSchedule?.[index];
                return (
                  <>
                    <tr key={apiItem.id}>
                      <td>{apiItem?.lst_PaymentType?.value}</td>
                      {/* Data from saleInfoData */}
                      <td>
                        {/* <p>${dataItem?.newAmount !== null && dataItem?.newAmount !== 0 ? dataItem?.newAmount?.toFixed(2)?.toLocaleString() : "0.00"}</p> */}
                      <p><FormattedNumber value={dataItem?.newAmount} />
                      </p>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default SummaryWizardData